export default {
  // Currency selection
  selectCurrency: "Select Currency",

  // Loading
  loading: "Loading...",

  // Address transfer status
  addressTransferStatus: "Address Transfer Status",
  dataStatisticsCurrency: "Data Statistics Currency: ",
  transactionAmount: "Transaction Amount",
  transactionCount: "Transaction Count",
  inflow: "Inflow",
  outflow: "Outflow",
  amount: "Amount",
  times: "Times",

  // Empty state
  noData: "No data",

  // Fund movement
  fundMovement: "Fund Movement Status",
  majorInflow: "Major Inflow",
  majorOutflow: "Major Outflow",
  frequentCounterparty: "Frequent Counterparty",

  // Withdrawal pattern
  withdrawalPattern: "Withdrawal Pattern",
};
